<!-- eslint-disable -->
<template lang="pug">
		cs-modal(@close="$emit('close')", :is-blur="true")
				div(slot="header")
						| {{ $i18n.t('conversations.conversations_conversationUsers_conversationMembers') }}
				.users-preview
						.row
								.col-xs-12.col-md-6(v-for="user in users" :key="user.id")
										router-link.users-preview__link(
												:to="{name: 'user:profile', params: {id: user.id, type: user.type}}"
										)
												img.users-preview__avatar(:src="user.avatar")
												| {{ user.fullName }}
						.modal-buttons
								cs-button(
										color="blue"
										@click="$emit('close')"
								)
										| {{ $i18n.t('conversations.conversations_conversationUsers_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import CsModal from '../elements/CsModal.vue'

    export default {
        props: ['users'],
		    components: {CsModal}
    }
</script>

<style lang="scss" scoped>
		.users-preview__link {
				display: flex;
				align-items: center;
				margin: 20px 10px;


				color: $hsl-color-blue-56;
				text-decoration: underline;
				&:hover {
						color: $hsl-color-blue-56;
						text-decoration: none;
				}
		}

		.users-preview__avatar {
				border-radius: 50%;
				margin-right: 30px;
				max-height: none;
				height: 80px;
				width: 80px;
				border: none;
		}
</style>
